$('.block-text p').each(function () {
  $('a', this).each(function () {
    if (!this.alt && !this.title) {
      $(this).attr('alt', this.text).attr('title', this.text);
    }
  });
});
